<template>
  <div class="d-flex flex-column gap-6 all-height all-width pa-6" data-testid="email-notification">
    <NotificationHeader
      data-testid="email-notification__header"
      @refresh="refreshData" />
      <v-card class="pa-3" elevation="0" data-testid="email-notification__card" rounded-xl> 
    <div>
      <div
        class="d-flex flex-column gap-4"
        v-if="!isClientNotEnabled"
        data-testid="email-notification__main-panel"
      >
       <v-tabs v-model="activeTab" background-color="transparent" class="emails-tabs">
          <v-tab v-for="(tab, index) in NotificationTabs" :key="index">
            {{ tab.label }}
          </v-tab>
        </v-tabs>
          <v-tabs-items v-model="activeTab" background-color="transparent" elevation="0" class="transparent-tabs-items">
          <!-- RU Wise Tab -->
          <v-tab-item key="0" class="">
            <div class="d-flex flex-column gap-4">
              <div class="d-flex" >
                 <v-spacer></v-spacer>
              <v-btn color="primary" @click="createNotification()">
                <v-icon left>mdi-plus-circle-outline</v-icon>
                Create notification
                </v-btn>
              </div>
              <div class="">
            <NotificationTable
            data-testid="email-notification__table"
            :headers="currentHeaders"
            :items="currentData"
            :slots="currentSlots"
            :loading="notificationsLoading"
            :isSchedulersTab="isSchedulersTab"
            @disableEnable="disableEnableNotification"
            @edit="editNotification"
            class="scroll-non"
          />
              </div>
              </div>
          </v-tab-item>
           <v-tab-item key="1" class="">
              <div>
            <NotificationTable
            data-testid="email-notification__table"
            :headers="currentHeaders"
            :items="currentData"
            :slots="currentSlots"
            :loading="notificationsLoading"
            :isSchedulersTab="isSchedulersTab"
            @disableEnable="disableEnableNotification"
            @edit="editNotification"
            :loadingStatus="isUpdatingStatus"
            class="scroll-non"
          />
              </div>
          </v-tab-item>
          </v-tabs-items>
      </div>
      <NotificationNotEnabledMessage
      v-else-if="!notificationsLoading && isClientNotEnabled"
      :message="notificationDisabledMessage"
      data-testid="email-notification__not-enabled-message"
    />
    </div>
    </v-card>
    <NotificationDialog
      data-testid="email-notification__dialog"
      :dialog.sync="createNotificationDialog"
      :loading="isSavingNotification"
      :featureData="featureData"
      :dropdownNotifications="dropdownNotifications"
      :latestPeriods="latestPeriods"
      :availableNotifications="availableNotifications"
      :activeTab="activeTab"
      @update="updateNotification"
      @add="addNotification"
    /> 
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  getEmailNotificationTableHeadersForSchedulersType,
  getEmailNotificationCoverageMonths,
  getEmailNotificationTableHeadersForEventTypes,
  NOTIFICATIONS,
} from "../utils/constants";
import { EMAIL_NOTIFICATION } from "../../financialclose/utils/constants";
//  import Pagination from '../../../views/common/Pagination.vue';
 import NotificationNotEnabledMessage from "../../financialclose/components/NotificationNotEnabledMessage/NotificationNotEnabledMessage.vue";
 import NotificationDialog from "../components/Notifications/NotificationDialog.vue";
 import NotificationTable from "../components/Notifications/NotificationTable.vue";
 import NotificationHeader from "../components/Notifications/NotificationHeader.vue";

export default {
  name: "EmailNotification",
  components: {
     NotificationNotEnabledMessage,
     NotificationDialog,
     NotificationTable,
     NotificationHeader
    // Pagination,
  },
  data() {
    return {
       NotificationTabs: [
        { label: 'Scheduled', value: 'schedulers' },
        { label: 'Real Time', value: 'realtime' },
      ],
      headers: getEmailNotificationTableHeadersForSchedulersType(),
      latestPeriods: getEmailNotificationCoverageMonths(),
      createNotificationDialog: false,
      featureData: {
        scheduler: "24",
        status: true,
        periodCount: 1,
      },
      schedulers: NOTIFICATIONS.NOTIFICATION_TYPE.SCHEDULERS,
      activeTab: 0,
      realTime: NOTIFICATIONS.NOTIFICATION_TYPE.REALTIME,
      notificationDisabledMessage:
        EMAIL_NOTIFICATION.MESSAGES.NOTIFICATION_NOT_ENABLED,
      eventTypeTableHeaders: getEmailNotificationTableHeadersForEventTypes(),
    };
  },
  async created() {
   await this.createRealTimeNotifications();
    this.refreshData();
  },
  beforeDestroy() {
    this.RESET_STATE();
  },
  watch: {
    activeTab() {
      this.createNotificationDialog = false;
      // filterAvailableNotifications is now computed
    },
    /**
     * Reset featureData when dialog closes to prevent stale data on next edit
     */
    createNotificationDialog(val) {
      if (!val) {
        this.resetFeatureData();
      }
    },
  },
  computed: {
    ...mapGetters("varianceanalysis/notification", [
      "notifications",
      "availableFeatures",
      "isLoadingNotifications",
      "isLoadingFeatures",
      "isClientNotEnabled",
      "isSavingNotification",
      "isUpdatingStatus",
      "schedulersData",
      "realTimeData",
    ]),
    isSchedulersTab() {
      return this.activeTab === 0;
    },
    currentData() {
      return this.isSchedulersTab ? this.schedulersData : this.realTimeData;
    },
    currentHeaders() {
      return this.isSchedulersTab ? this.headers : this.eventTypeTableHeaders;
    },
    currentSlots() {
      return this.isSchedulersTab
        ? NOTIFICATIONS.ENABLED_SLOTS.SCHEDULER
        : NOTIFICATIONS.ENABLED_SLOTS.REALTIME;
    },
    notificationsLoading() {
      return this.isLoadingNotifications || this.isLoadingFeatures;
    },
    availableNotifications() {
      const currentType = this.isSchedulersTab ? this.schedulers : this.realTime;
      const createdFeatures = new Set(
        this.notifications
          .filter((n) => n?.notificationType === currentType)
          .map((n) => n?.feature)
      );
      return this.availableFeatures.filter(
        (f) => f?.notificationType === currentType && !createdFeatures.has(f?.name)
      );
    },
    dropdownNotifications() {
      // If editing, ensure the current feature is in the dropdown
      if (this.featureData._id) {
        console.log(this.availableNotifications,"availableNotifications" ,this.featureData);
        
        const currentFeatureName = this.featureData.feature;
        // Filter out the current feature from availableNotifications to avoid duplicates
        const filteredAvailable = this.availableNotifications.filter(
          (notification) => notification.name !== currentFeatureName
        );

        // Find the current feature from all features
        const currentFeature = this.availableFeatures.find(
          (feature) => feature?.name === currentFeatureName
        );

        if (currentFeature) {
          return [currentFeature, ...filteredAvailable];
        }
        return filteredAvailable;
      }
      return this.availableNotifications;
    },
  },
  methods: {
    ...mapActions("varianceanalysis/notification", [
      "createRealTimeNotifications",
      "fetchNotifications",
      "fetchAvailableFeatures",
      "saveNotification",
    ]),
    ...mapMutations("varianceanalysis/notification", ["RESET_STATE"]),

    /**
     * Resets featureData to default values
     * Called when dialog closes to prevent stale state
     */
    resetFeatureData() {
      this.featureData = {
        scheduler: "24",
        status: true,
        feature: "",
        periodCount: 1,
      };
    },

    async refreshData() {
      console.log("[EmailNotification]: refreshData called");
      await Promise.all([
        this.fetchNotifications(),
        this.fetchAvailableFeatures()
      ]);
    },
    
    createNotification() {
      this.resetFeatureData();
      this.createNotificationDialog = true;
    },

    async disableEnableNotification(item, type) {
      if (!item) return;
      const flag = type === "enable";

      const data =
        item?.notificationType === this.schedulers
          ? {
              _id: item._id,
              schedulerTiming: "0 0 * * *",
              flag,
              type: NOTIFICATIONS.TYPE,
              feature: item?.feature,
            }
          : {
              _id: item._id,
              flag,
              type: NOTIFICATIONS.TYPE,
              feature: item?.feature,
            };
      
      try {
        await this.saveNotification({ data, isStatusUpdate: true, isUpdate: true });
      } catch (err) {
        // Error handled in store
      }
    },

    editNotification(item) {
      if (!item) return;
      console.log("[EmailNotification]: editNotification called with item:", item);
      
      // Reset first, then set new values to ensure clean state
      this.resetFeatureData();
      
      // Use $nextTick to ensure reset is complete before setting new values
      this.$nextTick(() => {
        this.featureData = {
          scheduler: item.scheduler || "24",
          status: item.status,
          feature: item.feature,
          _id: item._id,
          labelName: item.labelName,
          periodCount: item?.periodCount ?? 1,
          notificationType: this.schedulers,
        };
        this.createNotificationDialog = true;
        console.log("[EmailNotification]: featureData set:", this.featureData);
      });
    },
    async updateNotification(localFeatureData) {
      if (!this.validateFields(localFeatureData)) {
        return;
      }
      const data = {
        _id: localFeatureData._id,
        schedulerTiming: "0 0 * * *",
        flag: localFeatureData.status,
        type: NOTIFICATIONS.TYPE,
        feature: localFeatureData.feature,
        meta: {
          periodCount: localFeatureData?.periodCount,
        },
      };
      
      try {
        await this.saveNotification({ data, isUpdate: true });
        this.createNotificationDialog = false;
      } catch (err) {
        console.error("[EmailNotification]: API Error:", err);
      }
    },
    async addNotification(localFeatureData) {
      if (!this.validateFields(localFeatureData)) {
        return;
      }
      let data = {
        schedulerTiming: "0 0 * * *",
        flag: localFeatureData.status,
        type: NOTIFICATIONS.TYPE,
        feature: localFeatureData.feature,
        notificationType: this.schedulers,
        meta: {
          periodCount: localFeatureData?.periodCount ?? 1,
        },
      };

      try {
        await this.saveNotification({ data, isUpdate: false });
        this.createNotificationDialog = false;
      } catch (err) {
        // Error handled in store
      }
    },
    validateFields(fieldDetails) {
      console.log("[EmailNotification]: Validating fields:", fieldDetails);
      const requiredFields = NOTIFICATIONS.requiredFields;
      const currentTab = this.activeTab === 0 ? this.schedulers : this.realTime;
      const missingFields = requiredFields[currentTab]?.filter(
        (field) => {
          const value = fieldDetails[field];
          if (typeof value === "boolean") return false;
          return value === null || value === undefined || value.toString().trim() === "";
        }
      );
      if (missingFields?.length) {
        this.$store.commit(
          "sbError",
          `Please fill the required fields: ${missingFields?.join(", ")}.`
        );
        return false;
      }
      return true;
    },
  },
};
</script>

<style>

  .emails-tabs {
  border-bottom: 1px solid #e5e5e5;
  border-radius: 0;
}
.emails-tabs .v-tab {
  font-size: 18px;
  letter-spacing: 0.5px;
  line-height: 26px !important;
  font-weight: 400 !important;
}
.emails-tabs .v-tab--active {
  font-weight: 600 !important;
}
.emails-tabs.v-tabs-bar{
  height: 36px !important;
}
.transparent-tabs-items {
  background-color: transparent !important;
}
.show-count{
  border: 1px solid var(--color-hover-text-menu);
}
.scroll-non .v-data-table__wrapper {
  overflow-y: hidden !important;
}
</style>
